import React, { useState } from "react";
import PropTypes from "prop-types";
import "./AboutPage.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  SocialHandels,
  Card,
  HorizontalSlider,
  Slider,
  PhotoGallery,
} from "../../components";
import SecyHandel from "./SecyHandel.js";
import AboutTeams from "./aboutTeams.js";

const getEmbedUrlFromUtubeLink = (youtubeUrl) => {
  if (youtubeUrl.includes("embed")) return youtubeUrl;
  return `https://www.youtube.com/embed/${
    youtubeUrl.split("=")[1].split("&")[0]
  }?&autoplay=0`;
};

const getYoutubeVideoDimension = (type) => {
  const swidth = window.screen.availScreen;
  let x = swidth < 393 ? swidth / 640 : swidth < 893 ? 1.2 : 0.9;
  return type === "height" ? 360 * x : 640 * x;
};

const AboutPage = () => {
  const members = useSelector((state) => state.homePageMembers);
  const reviews = useSelector((state) => state.homeWhatCommunitySays);
  const urls = useSelector((state) =>
    state.homePageYoutubeLinks.map((surl) => getEmbedUrlFromUtubeLink(surl))
  );
  const [showFullIntro, setShowFullIntro] = useState(false);
  return (
    <div className="parent">
      <div
        className="hidden md:block homepage-container parallax half"
        id="home"
      ></div>
      <div className="homepage-container filter border shadow-md space-x-2 p-10 flex flex-col md:flex-row items-center justify-evenly ">
        <h1 className="heading font-semibold mr-4">हमारा परिचय</h1>
        <p className="text-[2rem] text-left border-l-2 p-10">
          हिन्दी हमारी बहुसंख्यक आबादी की मातृभाषा है। यह एक मज़बूत धागे की तरह
          है जो हमारे देश की विविधता में एकता को मज़बूत करते हुए, 28 अनमोल
          अद्वितीय मोतियों को एक साथ बाँधकर रखती है। यह हमें हमारे "एक भारत,
          श्रेष्ठ भारत" के दृष्टिकोण की दिशा में ले जाती है।
          <br />
          बढ़ते वैश्वीकरण के साथ, हम धीरे-धीरे अपनी जड़ों को भूलने लगे ,इसलिए
          हिंदी के महत्त्व पर प्रकाश डालने हेतु,
          <b> हिन्दी सहित्यिक एवं वाद-विवाद समिति (HLAD) </b>
          की स्थापना की गई थी। हिन्दी साहित्यिक एवं वाद-विवाद समिति ,छात्रों के
          अभिव्यक्ति कौशल और संपूर्ण व्यक्तित्व को विकसित करने के लिए जानी जाती
          है। समिति विभिन्न गतिविधियों जैसे कवि सम्मेलन, रचनात्मक लेखन,
          वाद-विवाद, प्रश्नोत्तरी, विभिन्न कार्यक्रमों का मंच संचालन एवं
          कार्यशालाओं के माध्यम से छात्रों को उभरने का अवसर प्रदान करती है।
          <br /> <br />
          {window.screen.availWidth >= 768 || showFullIntro ? (
            `जैसा कि कहा जाता है कि संसार तीन मूल भागों में विकसित है - "आकाश",
          "धरती" एवं "पाताल"। ठीक उसी भांति हिन्दी साहित्यिक एवं वाद-विवाद समिति
          के भी तीन मुख्य अविभाजनिय अंग हैं।
          लेखन दल जैसे "आकाश"। जिस भांति अंबर अनंत है, उसी भांति इनके विचार भी !
          लेखन टीम अपनी खूबसूरत सोच व रचनात्मक लेख के लिए जानी जाती है। लेखन का
          संपूर्ण कार्य इसी टीम के अंतर्गत आता है। वक्तृत्व दल जैसे "धरती"। जिस
          प्रकार धरती सदैव जमींदोज रहती हैं उसी प्रकार वक्तृत्व टीम ये जानते हुए
          कि व्यक्ति के बोलने का तरीका उसके व्यक्तित्व को उजागर करता है, छात्रों
          के आत्मविश्वास और संपूर्ण व्यक्तित्व को विकसित करने में सहायता करती है
          और उनके व्यक्तित्व को निखारती है। जिस प्रकार "पाताल" अदृश्य होकर ,आकाश
          और पृथ्वी को अपने ऊपर संजोये हुए है। उसी प्रकार ,डिजाइन टीम ,समिति के
          लिए रचनात्मक और आकर्षक पोस्टर डिजाइन करते हुए पिछले-छोर पर काम करती
          है। हिन्दी साहित्यिक एवं वाद-विवाद समिति संस्थान में आयोजित होने वाले
          सांस्कृतिक एवं तकनीकी उत्सवों के दौरान मंच संचालन, पत्रकारिता, पोस्टर
          डिजाइन एवं विभिन्न लेखन कार्यों में अपनी विशेष भूमिका निभाती है।`
          ) : (
            <strong
              className="text-blue-500"
              onClick={() => setShowFullIntro(true)}
            >
              अधिक जानें
            </strong>
          )}
        </p>
      </div>
      <div className="homepage-container" id="members-slideshow">
        <h1 className="heading font-semibold mr-4">समिति सदस्य</h1>
        <HorizontalSlider
          data={members}
          heading=""
          // hideSlideButtons={}
          scaleWidth={0.6}
          hideDots={true}
          renderComponent={(smember, i) => (
            <Card
              key={`member-${i}`}
              mainText={smember.Name}
              scale={1.1}
              subText={smember.Position}
              bodyText={smember.About}
              photoUrl={smember.photoUrl}
            />
          )}
        />
      </div>
      <div
        className="homepage-container flex flex-col items-center"
        id="teams-slideshow"
      >
        <h1 className="heading font-semibold mr-4">समिति के समूह</h1>
        <AboutTeams />
      </div>
      <div className="homepage-container" id="social-slideshow">
        <h1 className="heading font-semibold mr-4"> सोशल मीडिया चैनल</h1>
        <SocialHandels cardScale={0.56} flexDirection="row" />
      </div>
      <div className="homepage-container" id="youtube-slideshow">
        <h1 className="heading font-semibold mr-4"> हमारा यूट्यूब चैनल</h1>
        <HorizontalSlider
          data={urls}
          hideSlideButtons={window.screen.availWidth < 993}
          scaleWidth={
            window.screen.availWidth < 393
              ? 1
              : window.screen.availWidth < 893
              ? 1
              : 0.6
          }
          heading=""
          renderComponent={(surl, index) => (
            <iframe
              height={getYoutubeVideoDimension("height")}
              width={getYoutubeVideoDimension("width")}
              src={surl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          )}
        />
      </div>
      {/* <PhotoGallery /> */}
      {/* <div className="homepage-container" id="review-slideshow">
        <HorizontalSlider
          data={reviews}
          heading="What the Community Says ?"
          renderComponent={(sreview, i) => (
            <div
              key={`communityReview-${i}`}
              className="shadowCss"
              style={{
                minWidth: "300px",
                maxWidth: "600px",
                width: "60vw",
                backgroundColor: "white",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  className="shadowCss"
                  src={sreview.photoUrl}
                  alt=""
                  style={{
                    height: "60px",
                    width: "60px",
                    borderRadius: "50%",
                    margin: "20px",
                    borderWidth: "1px",
                    borderColor: "#d0d0d0",
                    objectFit: "cover",
                  }}
                />
                <h2 style={{ fontWeight: "bold", color: "rgba(0,0,0,0.7)" }}>
                  {sreview.nameAndDetail}
                </h2>
              </div>
              <p
                style={{
                  color: "rgba(0,0,0,0.7)",
                  margin: "20px",
                  marginTop: "0px",
                }}
              >
                {sreview.review}
              </p>
            </div>
          )}
        />
      </div> */}
    </div>
  );
};

AboutPage.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  homePageReducer: PropTypes.object.isRequired,
};

export default AboutPage;
